/* src/app/views/dashboard/components/sidebar-nav/nav-item/nav-item.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.nav-bar-icon,
.nav-bar-icon-filled {
  height: 100%;
  width: 1.5rem;
  display: inline-block;
  opacity: 0.7;
}
.nav-bar-icon-filled {
  display: none;
}
.nav-item:hover .nav-bar-icon {
  opacity: 1;
}
.nav-item:hover .nav-item-label {
  color: #222222;
}
.nav-item-notification-pill {
  background-color: #fa5555;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  line-height: 0.625rem;
  font-size: 0.75rem;
  padding: 0.25rem 0.375rem;
  vertical-align: middle;
  border-radius: 1.125rem;
  min-width: 1.5rem;
  float: right;
  margin-top: 0.2rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-nav-item {
  display: block;
  cursor: pointer;
}
.nav-item {
  list-style: none;
  padding: 0.75rem 1rem;
  color: #222222;
  border-radius: 0.625rem;
  cursor: pointer;
  margin: 0.25rem 0.5rem;
}
.nav-item.active {
  background-color: #dadbde;
}
.nav-item.passive-selection {
  background-color: rgba(255, 255, 255, 0.1);
  color: #222222;
}
.nav-item.passive-selection .nav-item-label {
  height: 2.25rem;
  line-height: 2.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-item.passive-selection .nav-item-label.multi-line-label {
  line-height: 1.125rem;
}
.nav-item-label {
  display: inline-block;
  width: calc(100% - 4rem);
}
.nav-item-icon {
  display: inline-block;
}
.sidebar-logo {
  flex-grow: 0;
}
.nav-item.active .nav-item-label {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.nav-item.active .nav-bar-icon {
  display: none;
}
.nav-item.active .nav-bar-icon-filled {
  display: inline-block;
  opacity: 1;
}
.nav-item-label {
  font-size: 1rem;
  line-height: 1.125rem;
  text-align: left;
  vertical-align: middle;
  padding-left: 0.5rem;
  color: #222222;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.sub-list {
  display: block;
  overflow-y: hidden;
  transition-timing-function: ease-in-out;
  transition: height 0.25s;
}
/*# sourceMappingURL=nav-item.component.css.map */
